var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeApplication" },
    [
      !_vm.isComplete
        ? [
            _c("FinanceApplicationProgress", {
              attrs: {
                "current-step": _vm.step,
                "total-steps": _vm.totalSteps,
              },
            }),
            _vm._v(" "),
            _c("FinanceApplicationTitle", {
              attrs: {
                title: _vm.currentStep.title,
                excerpt: _vm.currentStep.excerpt,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "financeApplication__body" },
              [
                _c(
                  _vm.currentStep.component,
                  _vm._g(
                    {
                      tag: "Component",
                      attrs: {
                        "initial-values": _vm.currentStep.initialValues,
                        "window-width": _vm.windowWidth,
                      },
                    },
                    _vm.currentStep.events
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "financeApplication__footer" }, [
              _c(
                "button",
                {
                  staticClass:
                    "financeApplication__button financeApplication__button--outline",
                  attrs: { type: "button", disabled: _vm.isBackDisabled },
                  on: { click: _vm.onDecreaseStep },
                },
                [_vm._v("\n                Back\n            ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "financeApplication__button",
                  attrs: {
                    type: "button",
                    disabled: _vm.isNextDisabled || _vm.isSubmitting,
                  },
                  on: { click: _vm.onIncreaseStep },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.currentStep.step === _vm.totalSteps
                          ? "Finish"
                          : "Next"
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ]
        : _c("FinanceApplicationComplete", {
            attrs: {
              "utm-campaign": _vm.utmCampaign,
              "utm-medium": _vm.utmMedium,
              "utm-source": _vm.utmSource,
            },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }